import React from 'react'
import { useTranslation } from '../../services/static-text/hooks'
import OracleIconButton from './OracleIconButton'

export type OracleThumbValue = 'up' | 'down' | 'none'

interface OracleThumbsProps {
  value: OracleThumbValue
  onThumbsUp?: () => void
  onThumbsDown?: () => void
  className?: string
}

export const OracleThumbs: React.FC<OracleThumbsProps> = ({
  value,
  onThumbsUp,
  onThumbsDown,
  className = '',
}) => {
  const translate = useTranslation('oracleCommons') as unknown as (key: string) => string
  const thumbsUpLabel = translate('thumbsUp')
  const thumbsDownLabel = translate('thumbsDown')

  const baseClass = 'oracle-thumbs'
  const combinedClassName = `${baseClass} ${className}`.trim()

  const thumbsUpActiveClass = value === 'up' ? `${baseClass}__button--active` : ''
  const thumbsDownActiveClass = value === 'down' ? `${baseClass}__button--active` : ''

  return (
    <div className={combinedClassName}>
      <OracleIconButton
        icon={value === 'up' ? 'thumbs-up-filled' : 'thumbs-up'}
        aria-label={thumbsUpLabel}
        onClick={onThumbsUp}
        className={`${baseClass}__button ${thumbsUpActiveClass}`.trim()}
      />
      <OracleIconButton
        icon={value === 'down' ? 'thumbs-down-filled' : 'thumbs-down'}
        aria-label={thumbsDownLabel}
        onClick={onThumbsDown}
        className={`${baseClass}__button ${thumbsDownActiveClass}`.trim()}
      />
    </div>
  )
}
